import {
  SELECT_PROJECT,
  ROLLBACK_PROJECT,
} from 'store/services/project/actionTypes';
import * as types from './actionTypes';
import initialState from './initialState';

export default (state = initialState, action = {}) => {
  switch (action.type) {
    case types.GET_XPACKS_REQUEST:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: true,
        },
      };
    case types.GET_XPACKS_SUCCESS:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          data: {
            ...state.list.data,
            items: action.payload.xpacks,
            count: action.payload.count,
          },
        },
      };
    case types.GET_XPACKS_ERROR:
      return {
        ...state,
        list: {
          ...state.list,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_XPACKS_PAGINATION_PARAMS:
      return {
        ...state,
        list: {
          ...state.list,
          paginationOptions: action.payload.paginationOptions,
        },
      };
    case types.ADD_XPACK_REQUEST:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: true,
        },
      };
    case types.ADD_XPACK_SUCCESS:
    case types.CANCEL_ADD_XPACK:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
        },
      };
    case types.ADD_XPACK_ERROR:
      return {
        ...state,
        add: {
          ...state.add,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.UPDATE_XPACK_REQUEST:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: true,
        },
      };
    case types.UPDATE_XPACK_SUCCESS:
    case types.CANCEL_UPDATE_XPACK:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
        },
      };
    case types.UPDATE_XPACK_ERROR:
      return {
        ...state,
        update: {
          ...state.update,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.DELETE_XPACK_REQUEST:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: true,
          data: action.payload.xpack,
        },
      };
    case types.DELETE_XPACK_SUCCESS:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
          data: {},
        },
      };
    case types.DELETE_XPACK_ERROR:
      return {
        ...state,
        delete: {
          ...state.delete,
          isLoading: false,
          error: action.payload.error,
          data: {},
        },
      };
    case types.DOWNLOAD_XPACK_REQUEST:
      return {
        ...state,
        download: {
          ...state.download,
          isLoading: true,
        },
      };
    case types.DOWNLOAD_XPACK_SUCCESS:
      return {
        ...state,
        download: {
          ...state.download,
          isLoading: false,
        },
      };
    case types.DOWNLOAD_XPACK_ERROR:
      return {
        ...state,
        download: {
          ...state.download,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.OVERRIDE_ALL_XPACK_INTENTS_REQUEST:
      return {
        ...state,
        overrideAllXpackIntents: {
          ...state.overrideAllXpackIntents,
          isLoading: true,
          error: '',
        },
      };
    case types.OVERRIDE_ALL_XPACK_INTENTS_COMPLETE:
      return {
        ...state,
        overrideAllXpackIntents: {
          ...state.overrideAllXpackIntents,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case types.DISABLE_ALL_XPACK_INTENTS_REQUEST:
      return {
        ...state,
        disableAllXpackIntents: {
          ...state.disableAllXpackIntents,
          isLoading: true,
          error: '',
        },
      };
    case types.DISABLE_ALL_XPACK_INTENTS_COMPLETE:
      return {
        ...state,
        disableAllXpackIntents: {
          ...state.disableAllXpackIntents,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case SELECT_PROJECT:
    case ROLLBACK_PROJECT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
